import React, { FC } from 'react';
import { Content, Description, GoButton, Title } from './styled';
import DOMPurify from 'dompurify';

interface IProps {
    title: string;
    description: string;
    buttonText: string;
    action: () => void;
    color?: 'error' | 'primary' | undefined;
    atSelector?: string;
}

export const SendMessage: FC<IProps> = ({
    title,
    description,
    action,
    buttonText,
    color = 'primary',
    atSelector,
}) => (
    <Content data-at-selector={`${atSelector}-content`}>
        <Title data-at-selector={`${atSelector}-title`}>{title}</Title>
        <Description
            data-at-selector={`${atSelector}-description`}
            dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(description),
            }}
        />
        <GoButton
            atSelector={`${atSelector}-button`}
            color={color}
            size={'small'}
            onClick={action}>
            {buttonText}
        </GoButton>
    </Content>
);
